export const ORDER_CANCEL_VALID_STATUSES = [
  'ready',
  'printing',
  'printed',
  'picksorted',
  'picked',
  'preorder',
  'unvalidated',
  `can't find`,
  'verify',
];

export const ORDER_SHIP_TO_COUNTRY = {
  INTERNATIONAL: 'international',
  DOMESTIC: 'domestic',
};
